import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import glassTheme from '../styles/glassTheme';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  transition: transform ${glassTheme.transition.base};

  &:hover {
    transform: scale(1.05);
  }
`;

const LogoImage = styled.img`
  height: 2rem;
  filter: drop-shadow(0 0 10px rgba(96, 165, 250, 0.5));
`;

const LogoText = styled.span`
  font-size: 1.5rem;
  font-weight: bold;
  background: ${glassTheme.gradients.cyber};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

interface LogoProps {
  onClick?: () => void;
}

export const Logo: React.FC<LogoProps> = ({ onClick }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate('/');
    }
  };

  return (
    <LogoContainer onClick={handleClick}>
      <LogoImage src="/statquest.png" alt="StatQuest" />
      <LogoText>StatQuest with AI</LogoText>
    </LogoContainer>
  );
};
